export default __webpack_public_path__ + "static/media/first-mind.bc6db7e9.jpg";